export default __webpack_public_path__ + "static/media/showreel.9afdfa87.mp4";